export default "__VITE_ASSET__8330ac96__"